export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11269.0db7233b.jpg";